import React from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import { useAuth } from '../contexts/AuthContext';

const Dashboard = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, minHeight: '100vh', bgcolor: '#f6f7f8' }}>
      <Sidebar onLogout={handleLogout} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 2, md: 4 },
          pt: { xs: 7, md: 4 },
        }}
      >
        <Typography variant="h3" sx={{ color: '#0e141b', fontWeight: 900, mb: 2, fontSize: { xs: '1.875rem', md: '2.25rem' } }}>
          Dashboard
        </Typography>
        <Typography sx={{ color: '#4e7397' }}>
          Bienvenido al sistema de gestión de Frigorífico Capriata
        </Typography>
      </Box>
    </Box>
  );
};

export default Dashboard;
